import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "circle-checkmark",
  "use": "circle-checkmark-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"circle-checkmark\"><path d=\"M3.735 8.956l3.017 3.017 5.28-5.28a1.039 1.039 0 00-1.463-1.463L6.796 9 5.244 7.448c-1.067-1.066-2.575.442-1.509 1.509z\" /><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8 16A8 8 0 118 0a8 8 0 010 16zm0-1A7 7 0 118 1a7 7 0 010 14z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol